package com.tovtalk.ui.components

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.tovtalk.ui.adaptive.LocalWindowSizeClass
import com.tovtalk.ui.adaptive.WindowSizeClass

@Composable
fun CenteredContentWrapper(
    maxWidth: Dp = 600.dp,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    val windowSizeClass = LocalWindowSizeClass.current
    if (windowSizeClass == WindowSizeClass.Compact) {
        content()
    } else {
        Box(
            modifier = modifier.fillMaxSize(),
            contentAlignment = Alignment.TopCenter
        ) {
            Box(modifier = Modifier.widthIn(max = maxWidth).fillMaxHeight()) {
                content()
            }
        }
    }
}
